import { UserRole } from "@/types/auth";

// O que cada perfil acessa (exibido em Usuários e no formulário de usuário).
export const ROLE_INFO: Record<UserRole, { label: string; description: string; tone: string }> = {
  "account-admin": {
    label: "Administrador",
    description: "Acesso completo: relatórios, ferramentas, integrações, assinatura, dados cadastrais e usuários.",
    tone: "admin",
  },
  "finance-manager": {
    label: "Financeiro",
    description: "Relatórios, assinatura, planos e produtos, dados cadastrais e financeiro.",
    tone: "finance",
  },
  analyst: { label: "Analista", description: "Relatórios, Gerador de link, Vitrine e integrações.", tone: "analyst" },
  reader: { label: "Leitor", description: "Só visualiza os relatórios.", tone: "reader" },
};

export const ROLE_ORDER: UserRole[] = ["account-admin", "finance-manager", "analyst", "reader"];

// Analytics Pro: o Leitor só vê análises prontas (não envia, reanalisa,
// exclui nem configura IA).
export const PRO_EDITOR_ROLES: UserRole[] = ["account-admin", "finance-manager", "analyst"];
